
export default function Merits() {
  const merits = [
    {
      icon: 'ri-store-2-line',
      title: '農産物直売所・ファーマーズマーケットで5%割引',
      description: '全国1,100店舗以上の農産物直売所・ファーマーズマーケットで、ご請求時にいつでも5%割引！新鮮な野菜や果物をおトクに購入できます。',
      highlight: 'いつでも5%OFF'
    },
    {
      icon: 'ri-gas-station-line',
      title: '提携給油所で1Lにつき2円割引',
      description: '全国2,000店舗以上の提携給油所で、ガソリン・軽油が1Lにつき2円割引！車をよく使う方に嬉しい特典です。',
      highlight: '1L=2円引き'
    },
    {
      icon: 'ri-add-circle-line',
      title: '提携店舗で+2%ポイント還元',
      description: '提携スーパー・購買店舗・通販サイト・旅行サービスなど提携施設で、通常ポイントに加えて+2%のポイント還元！',
      highlight: '+2%還元'
    }
  ];

  return (
    <section className="py-16 bg-[#F0FFF4]">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-4 text-center">
          地域密着型クレジットカードの3つのメリット
        </h2>
        <p className="text-gray-600 text-center mb-12">
          提携金融機関口座保有者だけが使える、地域密着型の特典が満載
        </p>

        <div className="grid md:grid-cols-3 gap-6">
          {merits.map((merit, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-[#00A040]/10 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className={`${merit.icon} text-3xl text-[#00A040] w-8 h-8 flex items-center justify-center`}></i>
              </div>
              <div className="inline-block bg-[#00A040] text-white text-xs font-bold px-3 py-1 rounded-full mb-3">
                {merit.highlight}
              </div>
              <h3 className="text-lg font-bold text-[#003366] mb-3">{merit.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{merit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
